//workflows
export enum EnumWorkflowsTypes {
    Phone                             = 'phone',
    Name                              = 'name',
    NameApi                           = 'name_api',
    Post                              = 'post',
    DeepWeb                           = 'deepweb',
    WebInt                            = 'webint',
    CombinedPhone                     = 'combined_phone',
    PhoneList                         = 'phone_list',
    CombinedEmail                     = 'combined_email',
    EmailList                         = 'email_list',
    CombinedName                      = 'combined_name',
    NameByCountry                     = 'name_by_country',
    CombinedId                        = 'combined_id',
    FaceSearch                        = 'face_search',
    AdditionalQuotas                  = 'additional_quotas',
    WebDataSearch                     = 'web_data_search',
    IrbisFacebook                     = 'irbis_facebook',
    IrbisInstagram                    = 'irbis_instagram',
    CroloX                            = 'crolo_x',
    CroloVk                           = 'crolo_vk',
    CroloOk                           = 'crolo_ok',
    IrbisTiktok                       = 'irbis_tiktok',
    BlueskyV3                         = 'bluesky_v3',
    FbPersonWallKeyword               = 'fb_person_wall_keyword',
    SentimentAnalysys                 = 'sentiment_analysys',
    IrbisEye                          = 'irbis_eye',
    ImageInsize                       = 'image_insize',
    PhotoSearcher                     = 'photo_searcher',
    Kyc                               = 'kyc',
    WebCollection                     = 'web_collection',
    IpGeo                             = 'ip_geo',
    IpgeoNumber                       = 'ipgeo_number',
    PsychoProfile                     = 'psycho_profile',
    ApiV2X                            = 'api_v2_x',
    ApiV2Instagram                    = 'api_v2_instagram',
    ApiV2Linkedin                     = 'api_v2_linkedin',
    LookupPhoneVerification           = 'lookup_phone_verification',
    LookupPhoneNameVerification       = 'lookup_phone_name_verification',
    RealPhone                         = 'real_phone',
    IrbisCriminal                     = 'irbis_criminal',
    SsnTrace                          = 'ssn_trace',
    NatCrimCheck                      = 'nat_crim_check',
    Pep                               = 'pep',
    CourtRecords                      = 'court_records',
    Adid                              = 'adid',
    AdidByPhone                       = 'adid_by_phone',
    AdidLocation                      = 'adid_location',
    GroupMembers                      = 'group_members',
    PsychoProfileSummary              = 'psycho_profile_summary',
    SnApiProfiler                     = 'sn_api_profiler',
    SnApiProfilerFbFriends            = 'sn_api_profiler_fb_friends',
    SnApiProfilerFbPosts              = 'sn_api_profiler_fb_posts',
    SnApiProfilerInstaFriends         = 'sn_api_profiler_insta_friends',
    SnApiProfilerInstaPosts           = 'sn_api_profiler_insta_posts',
    SnApiGroupProfiler                = 'sn_api_group_profiler',
    PublicCompanyInfo                 = 'public_company_info',
    CryptoWalletScreening             = 'crypto_wallet_screening',
    RegionMonitoring                  = 'region_monitoring',
    RegionMonitoringEntitiesExtract   = 'region_monitoring_entities_extract',
    IrbisProConcludeReport            = 'irbispro_conclude_report',
  }

export const SERVICE_TYPE_LABEL: Record<EnumWorkflowsTypes, string> = {
  [EnumWorkflowsTypes.Phone]:                   'Phone',
  [EnumWorkflowsTypes.Name]:                    'Name (Crawlers)',
  [EnumWorkflowsTypes.NameApi]:                 'Name Api (IRBIS SN)',
  [EnumWorkflowsTypes.Post]:                    'Post',
  [EnumWorkflowsTypes.DeepWeb]:                 'Deep WEB',
  [EnumWorkflowsTypes.WebInt]:                  'WebInt',
  [EnumWorkflowsTypes.CombinedPhone]:           'Advanced Phone Lookup',
  [EnumWorkflowsTypes.PhoneList]:               'Advanced Phone Lookup (List)',
  [EnumWorkflowsTypes.CombinedEmail]:           'Advanced E‑mail Lookup',
  [EnumWorkflowsTypes.EmailList]:               'Advanced E‑mail Lookup (List)',
  [EnumWorkflowsTypes.CombinedName]:            'Advanced Name Lookup',
  [EnumWorkflowsTypes.NameByCountry]:           'Advanced Name Lookup By Country',
  [EnumWorkflowsTypes.CombinedId]:              'Advanced ID Lookup',
  [EnumWorkflowsTypes.FaceSearch]:              'Face Search',
  [EnumWorkflowsTypes.AdditionalQuotas]:        'Add Quotas',
  [EnumWorkflowsTypes.WebDataSearch]:           'Facebook API (Crawlers)',
  [EnumWorkflowsTypes.IrbisFacebook]:           'Facebook API (IRBIS SN)',
  [EnumWorkflowsTypes.IrbisInstagram]:          'Instagram API (IRBIS SN)',
  [EnumWorkflowsTypes.CroloX]:                  'X API (IRBIS SN)',
  [EnumWorkflowsTypes.CroloVk]:                 'Vk API (IRBIS SN)',
  [EnumWorkflowsTypes.CroloOk]:                 'Ok API (IRBIS SN)',
  [EnumWorkflowsTypes.IrbisTiktok]:             'TikTok API (IRBIS SN)',
  [EnumWorkflowsTypes.BlueskyV3]:               'BlueSky API (IRBIS SN)',
  [EnumWorkflowsTypes.FbPersonWallKeyword]:     'Facebook API (person wall keyword, Crawlers)',
  [EnumWorkflowsTypes.SentimentAnalysys]:       'Sentiment Analysys',
  [EnumWorkflowsTypes.IrbisEye]:                'Irbis Eye',
  [EnumWorkflowsTypes.ImageInsize]:             'Photo Intel',
  [EnumWorkflowsTypes.PhotoSearcher]:           'Sniper API',
  [EnumWorkflowsTypes.Kyc]:                     'KYC',
  [EnumWorkflowsTypes.WebCollection]:           'WEB Collection',
  [EnumWorkflowsTypes.IpGeo]:                   'Geolocation',
  [EnumWorkflowsTypes.IpgeoNumber]:             'Geolocation By Phone',
  [EnumWorkflowsTypes.PsychoProfile]:           'PsychoProfile and Summary',
  [EnumWorkflowsTypes.ApiV2X]:                  'API v.2 ‑ X (Twitter)',
  [EnumWorkflowsTypes.ApiV2Instagram]:          'API v.2 ‑ Instagram',
  [EnumWorkflowsTypes.ApiV2Linkedin]:           'API v.2 ‑ LinkedIn',
  [EnumWorkflowsTypes.LookupPhoneVerification]: 'Validate Phone Lookup Results',
  [EnumWorkflowsTypes.LookupPhoneNameVerification]: 'Validate Phone Lookup By Name',
  [EnumWorkflowsTypes.RealPhone]:               'Real Phone',
  [EnumWorkflowsTypes.IrbisCriminal]:           'Irbis Criminal Checks (Out of date)',
  [EnumWorkflowsTypes.SsnTrace]:                'Social Security Number Trace',
  [EnumWorkflowsTypes.NatCrimCheck]:            'National Criminal Screening',
  [EnumWorkflowsTypes.Pep]:                     'Politically Exposed Persons',
  [EnumWorkflowsTypes.CourtRecords]:            'Court Records',
  [EnumWorkflowsTypes.CryptoWalletScreening]:   'Crypto Wallet Screening',
  [EnumWorkflowsTypes.Adid]:                    'AdID (get AdID by coordinates)',
  [EnumWorkflowsTypes.AdidByPhone]:             'AdID (get AdId by phone number)',
  [EnumWorkflowsTypes.AdidLocation]:            'AdID (get location by AdId)',
  [EnumWorkflowsTypes.GroupMembers]:            'Group Members Info',
  [EnumWorkflowsTypes.PsychoProfileSummary]:    'OSINT: PsychoProfile',
  [EnumWorkflowsTypes.SnApiProfiler]:           'OSINT: Social Network API Profiler (Common Profile Builder)',
  [EnumWorkflowsTypes.SnApiProfilerFbFriends]:  'OSINT: Social Network API Profiler (Facebook Friends)',
  [EnumWorkflowsTypes.SnApiProfilerFbPosts]:    'OSINT: Social Network API Profiler (Facebook Posts)',
  [EnumWorkflowsTypes.SnApiProfilerInstaFriends]:
                                            'OSINT: Social Network API Profiler (Instagram Friends)',
  [EnumWorkflowsTypes.SnApiProfilerInstaPosts]:
                                            'OSINT: Social Network API Profiler (Instagram Posts)',
  [EnumWorkflowsTypes.SnApiGroupProfiler]:      'WEBINT: Social Network API Profiler (Group Profile Builder)',
  [EnumWorkflowsTypes.PublicCompanyInfo]: 'Public Company Info',
  [EnumWorkflowsTypes.IrbisProConcludeReport]: 'Irbispro Conclude Report',
  [EnumWorkflowsTypes.RegionMonitoring]: 'Region Monitoring',
  [EnumWorkflowsTypes.RegionMonitoringEntitiesExtract]: 'Region Monitoring Entities Extract',
}

export const WORKFLOWS_TYPES = (Object.entries(SERVICE_TYPE_LABEL)
  .map(([id, text]) => ({ id: id as EnumWorkflowsTypes, text }))) 

//packages
export enum EnumPackagesActiveFiltersTypes {
    isEnabled = 'isActive',
    isDisabled = 'isNotActive',
  }

export const PACKAGE_ACTIVE_TYPE_LABEL: Record<EnumPackagesActiveFiltersTypes, string> = {
    [EnumPackagesActiveFiltersTypes.isEnabled]: 'Yes',
    [EnumPackagesActiveFiltersTypes.isDisabled]: 'No',
  }

export const PACKAGES_ACTIVE = (Object.entries(PACKAGE_ACTIVE_TYPE_LABEL)
  .map(([id, text]) => ({ id: id as EnumPackagesActiveFiltersTypes, text }))) 

export enum EnumPackagesIncludesAiFiltersTypes {
    isEnabled = 'isActive',
    isDisabled = 'isNotActive',
  }

export const PACKAGE_INCLUDES_AI_LABEL: Record<EnumPackagesIncludesAiFiltersTypes, string> = {
    [EnumPackagesIncludesAiFiltersTypes.isEnabled]: 'Yes',
    [EnumPackagesIncludesAiFiltersTypes.isDisabled]: 'No',
  }

export const PACKAGES_INCLUDES_AI = (Object.entries(PACKAGE_INCLUDES_AI_LABEL)
  .map(([id, text]) => ({ id: id as EnumPackagesIncludesAiFiltersTypes, text })))


export enum EnumPackagesTypesFiltersTypes {
  isGeneral = 'general',
  isPersonal = 'personal',
  isCustom  = 'custom',
  isTelegrambt = 'telegrambt',
  isWebinthub = 'webinthub',
  isWebinthubSubpackage = 'webinthub_subpackage',
  isWebinthubUpgrade = 'webinthub_upgrade',
  isDemo = 'demo',
  isWebinthubDemo = 'webinthub_demo',
  isOneTimeFee  ='one_time_fee',
}

export const PACKAGE_TYPES_LABEL: Record<EnumPackagesTypesFiltersTypes, string> = {
    [EnumPackagesTypesFiltersTypes.isGeneral]: 'General',
    [EnumPackagesTypesFiltersTypes.isPersonal]: 'Personal',
    [EnumPackagesTypesFiltersTypes.isCustom]: 'Customized',
    [EnumPackagesTypesFiltersTypes.isTelegrambt]: 'Telegram Bot',
    [EnumPackagesTypesFiltersTypes.isWebinthub]: 'IrbisPro',
    [EnumPackagesTypesFiltersTypes.isWebinthubSubpackage]: 'IrbisPro Subpackage',
    [EnumPackagesTypesFiltersTypes.isWebinthubUpgrade]: 'IrbisPro Upgrade',
    [EnumPackagesTypesFiltersTypes.isDemo]: 'Demo (General)',
    [EnumPackagesTypesFiltersTypes.isWebinthubDemo]: 'Demo (IrbisPro Personal)',
    [EnumPackagesTypesFiltersTypes.isOneTimeFee]: 'One Time Fee Package',
  }

export const PACKAGES_TYPES = (Object.entries(PACKAGE_TYPES_LABEL)
  .map(([id, text]) => ({ id: id as EnumPackagesTypesFiltersTypes, text })))